import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import properties from '../../../../../api/properties/hooks'
import { DataTableLayout, useDataTable, useTableState } from '../../../../../Components/TanstackTable'
import OpportunityDropDown from '../OpportunityDropDown/OpportunityDropDown'

const OpportunityTable = ({ tableKey, columns, url, entityType, showContact, onToggleFilter }) => {
    const { id } = useParams()

    const tableState = useTableState({ tableKey })

    const queryParams = {
        ...tableState.params,
        id,
        url,
        entityType,
    }

    const { isLoading: fetchingOpportunity, data: opportunityData } = properties.GetOpportunity.useQuery(queryParams)
    const opportunityItems = useMemo(() => opportunityData?.items ?? [], [opportunityData?.items])

    const { table } = useDataTable({
        ...tableState,
        columns,
        data: opportunityItems,
        pageCount: opportunityData?.pagination?.totalPages,
    })

    // OpportunityTable is also used in ProjectView, where dropdown is not needed
    const tableActions =
        entityType !== 'project' ? () => <OpportunityDropDown showContact={showContact} onToggleFilter={onToggleFilter} /> : undefined

    return (
        <DataTableLayout
            table={table}
            isLoading={fetchingOpportunity}
            totalItems={opportunityData?.pagination?.totalItems}
            theadClass="dmn-table-header"
            toolbarActions={tableActions}
        />
    )
}

export default OpportunityTable
